import React, { useState, useEffect, useRef, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  marqueeContainer: {
    position: 'fixed',
    top: 0,
    zIndex: 100,
    display: 'flex',
    overflow: 'hidden',
    width: '100%',
    background: '#D2F226',
    flexShrink: 0,
    flexGrow: 0,
    minHeight: '36px'
  },
  marquee: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    flexGrow: 0,
    flexBasis: 'auto',
    animation: '$marquee 45s linear infinite',
    fontWeight: theme.typography.fontWeightBold,
    color: '#000000'
  },
  marqueeElement: {
    paddingInline: theme.spacing(3),
    whiteSpace: 'pre',
    fontSize: '0.8rem',
    WebkitTextSizeAdjust: '100%'
  },
  '@keyframes marquee': {
    '0%': {
      transform: 'translateX(0)'
    },
    '100%': {
      transform: 'translateX(-100%)'
    }
  }
}));

const MarqueeDisplayBanner = ({ banner }) => {
  const classes = useStyles();

  const containerRef = useRef(null);
  const marqueeRef = useRef(null);
  const [multiplier, setMultiplier] = useState(1);
  const [isMounted, setIsMounted] = useState(false);

  const calculateWidth = useCallback(() => {
    const containerRect = containerRef.current?.getBoundingClientRect();
    const marqueeRect = marqueeRef.current?.getBoundingClientRect();
    const containerWidth = containerRect?.width;
    const marqueeWidth = marqueeRect?.width;

    if (containerWidth && marqueeWidth) {
      setMultiplier(
        marqueeWidth < containerWidth
          ? Math.ceil(containerWidth / marqueeWidth)
          : 1
      );
    }
  }, [containerRef]);

  const multiplyChildren = useCallback(
    multiplier => {
      const arraySize = multiplier;
      return [...Array(arraySize)].map((_, i) => (
        <React.Fragment key={i}>
          <span className={classes.marqueeElement}>{banner.message}</span>
        </React.Fragment>
      ));
    },
    [banner, classes.marqueeElement]
  );

  useEffect(() => {
    if (!isMounted) return;
    calculateWidth();
  }, [calculateWidth, containerRef, isMounted]);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!banner || !banner.message) {
    return null;
  }

  return (
    <div ref={containerRef} className={classes.marqueeContainer}>
      <div ref={marqueeRef} className={classes.marquee}>
        {multiplyChildren(multiplier).map(m => m)}
      </div>
      <div className={classes.marquee}>
        {multiplyChildren(multiplier).map(m => m)}
      </div>
    </div>
  );
};

export default MarqueeDisplayBanner;
